import React from 'react';
import PropTypes from 'prop-types';

import { ModalLauncher } from '@metarouter-private/mr-mui';

import CreateSampleEventButton from './CreateSampleEventButton';
import CreateSampleEventModal from './CreateSampleEventModal';

export default function CreateSampleEventAction({
  sampleEventJson,
  onSaveSuccess,
  disabled,
  disabledMessage,
  buttonSize,
}) {
  const launcherProps = {
    disabled,
    disabledMessage,
    size: buttonSize,
  };

  const modalProps = {
    eventJson: sampleEventJson,
    onSaveSuccess,
  };

  return (
    <>
      <ModalLauncher
        Launcher={CreateSampleEventButton}
        Modal={CreateSampleEventModal}
        launcherProps={launcherProps}
        modalProps={modalProps}
      />
    </>
  );
}

CreateSampleEventAction.propTypes = {
  sampleEventJson: PropTypes.string.isRequired,
  onSaveSuccess: PropTypes.func,
  disabled: PropTypes.bool,
  disabledMessage: PropTypes.string,
  buttonSize: PropTypes.oneOf(['small', 'medium', 'large']),
};
